/** Tokens visuais — cupons do evento (mesmo padrão dos recebimentos) */
export const CUPOM_ACCENT = "#F96030";
export const CUPOM_INK = "#1a2035";
export const CUPOM_ACCENT_SOFT = "rgba(249, 96, 48, 0.08)";

export const cupomToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${CUPOM_ACCENT}`,
};

export const cupomSectionSx = {
  p: { xs: 1.5, sm: 2 },
  borderRadius: 2,
  border: "1px solid",
  borderColor: "grey.200",
  bgcolor: "background.paper",
};

export const cupomModalPaperSx = {
  borderRadius: 3,
  overflow: "hidden",
  maxHeight: "92vh",
  display: "flex",
  flexDirection: "column" as const,
  width: { xs: "100%", sm: "96vw" },
  maxWidth: 920,
};

export const cupomModalHeaderSx = {
  px: 2.5,
  py: 2,
  background: `linear-gradient(135deg, ${CUPOM_INK} 0%, #2d3561 100%)`,
  color: "#fff",
  borderBottom: `3px solid ${CUPOM_ACCENT}`,
};
